export default __webpack_public_path__ + "static/media/BLAZE-Logo-Flat-White.1e6be97e.svg";